import { NavLink, Outlet } from "react-router-dom";

const adminNavLinks = [
  { to: "/admin", label: "Dashboard", end: true },
  { to: "/admin/users", label: "Users", end: false },
  { to: "/admin/questions", label: "Questions", end: false },
  { to: "/admin/exams", label: "Exams", end: false },
  { to: "/admin/categories", label: "Categories", end: false },
  { to: "/admin/free-trial", label: "Free Trial", end: false },
];

export default function AdminLayout() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Admin Panel</h1>
        <p className="mt-1 text-sm text-gray-500">Manage the driving theory test platform</p>
      </div>

      <div className="flex items-center space-x-1 border-b border-gray-200 mb-8">
        {adminNavLinks.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) =>
              `px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                isActive
                  ? "border-primary-600 text-primary-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`
            }
          >
            {link.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
